import React from "react";

import ModalContext from "./Context";

export const withPrompt = Component => props => (
  <ModalContext.Consumer>
    {context => <Component {...props} prompt={context} />}
  </ModalContext.Consumer>
);
